import { NavLink } from "react-router-dom";
import AppLogo from "../../../components/AppLogo";
import { getLmsNavigationItems } from "../utils/lmsDashboardContent";

const LmsSidebar = ({ role, isOpen, onNavigate }) => {
  const links = getLmsNavigationItems(role);

  return (
    <aside className={isOpen ? "lms-sidebar open" : "lms-sidebar"} aria-label="LMS navigation">
      <AppLogo containerStyle="lms-sidebar-logo" textStyle="lms-sidebar-logo-text" />
      <nav>
        {links.map(({ label, path, icon: Icon }) => (
          <NavLink
            key={path}
            to={path}
            end={path === "/dashboard"}
            onClick={onNavigate}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <Icon aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default LmsSidebar;
